import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ff9800',
                secondary: '#f44336',
                accent: '#795548',
            },
        },
    },
});
